import { z } from 'zod'

/** 「その他」の自由記述の上限（varuna rm_survey_logic.FREE_TEXT_MAX_LENGTH と同じ） */
export const RM_FREE_TEXT_MAX_LENGTH = 200

const rmAnswerSchema = z.object({
  question_id: z.number().int().positive(),
  option_codes: z
    .array(z.string().min(1))
    .min(1, '選択肢を1つ以上選んでください'),
  free_text: z
    .string()
    .max(
      RM_FREE_TEXT_MAX_LENGTH,
      `${RM_FREE_TEXT_MAX_LENGTH}文字以内で入力してください`
    )
})

/** submitRmAnswer/ の JSON ボディ */
export const rmSurveySubmitSchema = z.object({
  uuid: z.string().min(1),
  rm_condition_id: z.number().int().positive(),
  rm_display_history_id: z.number().int().positive().nullable(),
  format_id: z.string(),
  device_flag: z.enum(['SP', 'PC']),
  app_flag: z.string(),
  site_flag: z.string(),
  answers: z.array(rmAnswerSchema).min(1).max(2)
})

export type RmSurveySubmitBody = z.infer<typeof rmSurveySubmitSchema>
